/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MessageStatus model module.
 * @module model/MessageStatus
 * @version 1.0.0
 */
class MessageStatus {
    /**
     * Constructs a new <code>MessageStatus</code>.
     * Message&#39;s status data
     * @alias module:model/MessageStatus
     * @param id {Number} 
     * @param name {String} 
     */
    constructor(id, name) { 
        
        MessageStatus.initialize(this, id, name);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, id, name) { 
        obj['id'] = id;
        obj['name'] = name;
    }

    /**
     * Constructs a <code>MessageStatus</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MessageStatus} obj Optional instance to populate.
     * @return {module:model/MessageStatus} The populated <code>MessageStatus</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MessageStatus();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
MessageStatus.prototype['id'] = undefined;

/**
 * @member {String} name
 */
MessageStatus.prototype['name'] = undefined;






export default MessageStatus;

